/**
 * @CopyRight (C) 2016 and onwards HuaSheng Group All Rights Reserved.
 * @desc: 处理语言相关的工具方法
 */
import { LANG__zh_CN, LANG__zh_HK, LANG__en_US } from '@hst/constant';
import { inApp, getLangCode } from '@hst/utils';
import { isHK } from 'src/config/env';

// 未定义在插件方法里
const LANG__ms_MY = 'ms_MY';

const supportLangs = [LANG__en_US, LANG__zh_CN, LANG__zh_HK, LANG__ms_MY];

export function getLang() {
	// const { context } = { ...opts };
	let language = '';
	const defaultLanguage = isHK ? LANG__zh_HK : LANG__en_US;
	// if (isBrowser)
	language = getLangCode({
		isNeedGetUrl: true,
		isNeedGetCookie: !inApp(),
		defaultKey: defaultLanguage,
		zhCN: LANG__zh_CN,
		zhHK: LANG__zh_HK,
		enUS: LANG__en_US,
		msMY: LANG__ms_MY,
	});
	// if (isServer && context?.req)
	// 	language = getLangCodeByServer({
	// 		host: context.req.host,
	// 		query: context.req.query,
	// 		ua: context.req.headers['user-agent'],
	// 		cookies: context.req.headers.cookie,
	// 		isNeedGetCookie: !inApp({ customUA: context.req.headers['user-agent'] }),
	// 		isNeedGetUrl: !inApp({ customUA: context.req.headers['user-agent'] }),
	// 		defaultKey: LANG__en_US,
	// 	});

	if (!language) language = defaultLanguage;
	// 个别项目可能没有英文，可以在这里将英文环境输出繁体
	language = supportLangs.includes(language) ? language : LANG__zh_HK;
	return language;
}
